export default {
  PLACEHOLDER_SELECT_ADDRESS: 'Selecciona una dirección',
  INVOICES_MY_INVOICES: 'Mis facturas',
  INVOICES_INVOICES_PURCHASE_HISTORY: 'Facturas / Historial de pedidos',
  INVOICES_NO_INVOICES_FOUND: 'Por el momento no hay facturas disponibles.',
  INVOICES_ORDER_NUMBER: 'N.º de pedido',
  INVOICES_INVOICE_DATE: 'Fecha de la factura',
  INVOICES_PAYMENT_METHOD: 'Método de pago',
  INVOICES_PRICES: 'Precio',
  INVOICES_DOWNLOAD: 'Descargar',
  INVOICES_PER_PAGE: '/ página',
  PAYMENT_METHOD_CREDIT_CARD: 'Tarjeta de crédito',
  PAYMENT_METHOD_ADVANCED_PAYMENT: 'Transferencia bancaria',
  CHECKOUT_DELIVER_TO: 'Entrega a:',
  CHECKOUT_BILLING_TO: 'Facturar a:',
  CHECKOUT_SAMPLE_COPIES_ADDRESS: 'Dirección de envío de las muestras',
  CARD_ITEM_BUTTON_SAMPLE_COPIES: 'Muestras',
  CUSTOMER_SERVICE_TITLE: 'Servicio al Cliente',
  CUSTOMER_SERVICE_CONTACT: 'Contacto',
  CUSTOMER_SERVICE_AVAILABLE_FROM: 'Disponible a partir de las',
  CUSTOMER_SERVICE_AVAILABLE_UNTIL: 'Disponible hasta las',
  CHANGE_PW_TITLE: 'Debes cambiar tu contraseña.',
  CHANGE_PW_CHANGE: 'Actualizar datos',
  CHANGE_PW_CURRENT_PW: 'Contraseña actual*',
  CHANGE_PW_NEW_PW: 'Nueva contraseña*',
  CHANGE_PW_REPEAT_PW: 'Repetir nueva contraseña*',
  CHANGE_PW_EMAIL_MISMATCH: 'El correo electrónico no coincide con el usuario que ha iniciado sesión.',

  ASSERT_FIELD_REQUIRED: 'Este campo es obligatorio.',
  ASSERT_MINIMUM_LENGTH: 'Número mínimo de caracteres:',
  ASSERT_MAXIMUM_LENGTH: 'Número máximo de caracteres:',
  ASSERT_BOTH_FIELDS_MUST_BE_EQUAL: 'Ambos campos deben coincidir',
  ASSERT_INVALID_EMAIL: 'Introduce un correo electrónico válido',

  ASSERT_INVALID_PASSWORD:
    'La contraseña debe tener al menos 8 caracteres e incluir una letra mayúscula, una minúscula, un número y un carácter especial',
  AWS_COGNITO_ERROR_ATTEMPT_LIMIT: 'Demasiados intentos. Vuelve a intentarlo más tarde.',
  AWS_COGNITO_ERROR_USER_NOT_CONFIRMED:
    'Aún no has confirmado tu cuenta. Haz clic en el enlace que te hemos enviado por correo electrónico.',
  AWS_COGNITO_ERROR_PASSWORD_RESET_REQUIRED: 'Para iniciar sesión, primero debes restablecer tu contraseña.',
  AWS_COGNITO_ERROR_NETWORK: 'Se ha producido un problema de conexión. Vuelve a intentarlo en unos instantes.',
  AWS_COGNITO_ERROR_TOO_MANY_REQUESTS:
    'El servicio está ocupado en este momento. Vuelve a intentarlo en unos instantes.',
  AWS_COGNITO_ERROR_LIMIT_EXCEEDED:
    'Has realizado demasiadas solicitudes desde esta cuenta. Espera unos minutos y vuelve a intentarlo.',
  AWS_COGNITO_ERROR_SESSION_EXPIRED: 'Tu sesión ha caducado. Vuelve a iniciar sesión con la contraseña temporal.',

  LOGIN_EMAIL: 'Correo electrónico*',
  LOGIN_PASSWORD: 'Contraseña*',
  LOGIN_LOGIN: 'Iniciar sesión',
  LOGIN_FORGOT_PASSWORD: 'Restablecer contraseña',

  FORGOT_PASSWORD_CODE_SENT:
    'Si el correo electrónico está asociado a una cuenta, recibirás en breve un código de verificación por email.',
  FORGOT_PASSWORD_INVALID_CODE: 'Invalid verification code provided, please try again.',
  FORGOT_PASSWORD_SEND_CODE: 'Enviar código de verificación',
  FORGOT_PASSWORD_EMAIL: 'Correo electrónico*',
  FORGOT_PASSWORD_RESET_CODE: 'Código de verificación*',
  FORGOT_PASSWORD_NEW_PASSWORD: 'Nueva contraseña*',
  FORGOT_PASSWORD_REPEAT_NEW_PASSWORD: 'Repetir nueva contraseña*',
  FORGOT_PASSWORD_BACK_TO_LOGIN: 'Volver al inicio de sesión',
  FORGOT_PASSWORD_RESET_PASSWORD: 'Restablecer contraseña',
  FORGOT_PASSWORD_CODE_RESENT:
    'Si el correo electrónico está asociado a una cuenta, recibirás en breve un código de verificación por email.',
  FORGOT_PASSWORD_HINTS_TITLE: '¿No has recibido el correo electrónico?',
  FORGOT_PASSWORD_HINT_SPAM: 'Revisa la carpeta de spam o correo no deseado',
  FORGOT_PASSWORD_HINT_EMAIL: 'Comprueba que has introducido correctamente tu correo electrónico',
  FORGOT_PASSWORD_CHANGE_EMAIL: 'Modificar el correo electrónico',
  FORGOT_PASSWORD_HINT_RESEND: 'Reenviar código',
  LOGIN_RESEND_CONFIRMATION: 'Reenviar correo de confirmación',
  LOGIN_RESEND_CONFIRMATION_SUCCESS: 'Te hemos enviado otro correo de confirmación.',
  LOGIN_RESEND_CONFIRMATION_ERROR: 'No hemos podido enviarte el correo de confirmación. Inténtalo de nuevo más tarde.',
  SHOW_PASSWORD: 'Mostrar contraseña',
  HIDE_PASSWORD: 'Ocultar contraseña',

  MODAL_OK: 'Confirmar',
  MODAL_CANCEL: 'Cancelar',
  MODAL_DUPLICATE_FILE_TITLE: 'Archivo duplicado',
  MODAL_DUPLICATE_FILE_DESCRIPTION: 'Ya has subido un archivo con el siguiente nombre:',

  PLUS_MATERIAL_HINT: 'Ideales para inmersión en hielo',
  LOADING_DATA_ISSUE_JOB: 'Por favor, espere mientras recuperamos las configuraciones de su trabajo...',
  SHOW_UNIT_COUNT: 'Mostrar cantidad de unidades',
  LOT: 'LOT (Opcional)',
  LINE_1: 'línea 1',
  LINE_2: 'línea 2',
  LINE_3: 'línea 3',
  LINE_4: 'línea 4',
  PROOFING_SERVICE: 'Prueba de impresión',

  ORDER_TEMPLATES_TITLE: 'Plantillas de pedidos',
  ORDER_TEMPLATES_SELECT: 'Plantilla de pedido seleccionada',
  ORDER_TEMPLATES_SELECT_PLACEHOLDER: 'Por favor, seleccione una plantilla de pedido.',
  ORDER_TEMPLATES_NO_TEMPLATES: 'No hay plantillas de pedido disponibles.',

  PRODUCTION_TYPE_STANDARD: 'Estándar',
  PRODUCTION_TYPE_EXPRESS: '48h Exprés',
  PRODUCTION_TYPE_SUPER_EXPRESS: '24h Super Exprés',
  PRODUCTION_TYPE_ESTIMATED_SHIPPING_DATE: 'Envío estimado el',
  PRODUCTION_TYPE_SHIPPING_DATE: 'Envío el',
  PRODUCTION_TYPE_NOT_POSSIBLE: 'No es posible',

  SHOW_PRICE_IN_CURRENCY: 'Mostrar el precio en {currency}',
  CURRENCY_SWITCH_DISABLED_CART_NOT_EMPTY: 'La moneda no se puede cambiar mientras tu carrito tenga artículos.',
  CART_MIXED_CURRENCY_WARNING:
    'Tu carrito contiene artículos en diferentes monedas. Elimina los artículos en una moneda diferente antes de finalizar la compra.',
  CHECKOUT_USER_DISABLED:
    'Tu cuenta no tiene permiso para realizar pedidos. Ponte en contacto con nuestro servicio de atención al cliente.',
  DESIGN_SERVICE_CURRENCY_DISABLED: 'El servicio de diseño solo se puede pedir en {currency}.',
  PACKAGE_ORDER_CURRENCY_DISABLED: 'Este paquete solo se puede pedir en {currency}.',
  CHANGE_CURRENCY_CALCULATOR: 'Por favor, cambia primero la moneda en la calculadora de la página de inicio.',

  CART_ITEM_DISCOUNT_NOT_APPLICABLE:
    'No se concederá ningún descuento de cliente a este artículo debido a los precios especiales.',
  UPLOAD_SORTS_CONFIG_NOT_SAVED:
    'No se ha podido guardar la configuración de variantes. Por favor, compruebe que las cantidades de todas las variantes sumen la cantidad total e inténtelo de nuevo.',
  HPI_WHITE: 'Blanco opaco',
  YES: 'Si',
  NO: 'No',

  UPS_STANDARD_SHIPPING: 'UPS Standard',
  UPS_EXPRESS_SHIPPING: 'UPS Express Saver',
  UPS_STANDARD_SHIPPING_NEUTRAL: 'UPS Standard – Compensación de las emisiones de CO₂',
  UPS_EXPRESS_SHIPPING_NEUTRAL: 'UPS Express Saver – Compensación de las emisiones de CO₂'
} as const
